import Vue from "vue";
import Router from "vue-router";
import IndexRouter from './index-router'
import LiveDetailRouter from './likedetail-router'
import SeckillDetailRouter from './seckilldetail-router'
import MyPageRouter from './mypage-router'
import KPIRouter from "./kpi-router";
import MYRouter from "./my-router";
import store from './../store/index'

const indexRouterList = ['/prexxxx', '/prehttt', '/prehhh', '/prrheat', '/prehead', ]

let nowIndexRoute = '/prehddd'




Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};


const routes = [
  // 预热页，首页
  {
    path: "/",
    name: "index",
    redirect: "/prehddd",
    meta: {
      title: '首页',
      showBottom: true
    },
    component: resolve => require(["../pages/home/preheat.vue"], resolve),
  },



  // 二维码错误
  {
    path: "/errorPage",
    meta: {
      title: '出错啦',
      NOTAuth: true
    },
    component: resolve => require(["../pages/landingPage/errorPage.vue"], resolve),
  },
  // 逛店签到页面
  {
    path: "/signPage",
    meta: {
      title: '逛店签到',
      NOTAuth: true
    },
    component: resolve => require(["../pages/landingPage/signPage.vue"], resolve),
  },
  // 活动签到页面
  {
    path: "/actSignPage",
    meta: {
      title: '活动签到',
      NOTAuth: true
    },
    component: resolve => require(["../pages/landingPage/actSignPage.vue"], resolve),
  },
  // 登录
  {
    path: "/login",
    meta: {
      title: '加载中',
      NOTAuth: true
    },
    name: 'login',
    component: resolve => require(["../pages/login/login.vue"], resolve),
  },
  // 店铺首页
  {
    path: "/shop",
    meta: {
      title: '店面信息',
      showBottom: true
    },
    component: resolve => require(["../pages/shop/shop.vue"], resolve),
  },
  // 成为代言人
  // 被封List:["/spokesman"]
  {
    path: "/spokesmannew",
    meta: {
      title: '成为代言人'
    },
    component: resolve => require(["../pages/spokesman/spokesman.vue"], resolve),
  },
  //  集赞礼品
  {
    path: "/likedetailfour",
    component: resolve => require(["../pages/like-act/like-detail.vue"], resolve),
    meta: {
      title: '集赞礼品'
    },
    // 被封List:["likeDetail","likedetailnew","/likedetailone","/likedetailtwo","/likedetailthree"],当需要修改路由名时，router.js中也需同步修改集赞详情页的路由名（ios重刷新）
    // 建议全局搜索旧的路由名替换一下
    // 此处已修改到'./likedetail-router'配置
  },
  // 代金券详情
  {
    path: "/couponDetail",
    meta: {
      title: '会员福利'
    },
    component: resolve => require(["../pages/coupon/coupon-detail.vue"], resolve),
  },
  // 秒杀详情
  {
    path: "/seckillDetailNew",
    meta: {
      title: '秒杀详情'
    },
    component: resolve => require(["../pages/seckill/seckill-detail.vue"], resolve),
  },
  // 被封List:["seckillDetail"],当需要修改路由名时，router.js中也需同步修改秒杀详情页的路由名（ios重刷新）
  // 建议全局搜索旧的路由名替换一下
  // 此处已修改到'./seckilldetail-router'配置


  // 个人中心
  ...MYRouter,
  //kpi
  ...KPIRouter,

  // 首页
  ...IndexRouter,

  // 秒杀详情
  ...SeckillDetailRouter,

  // 集赞
  ...LiveDetailRouter,

  // 我的页面
  ...MyPageRouter

];


const router = new Router({
  mode: "history",
  routes,
});



router.beforeEach((to, from, next) => {




  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  let url1 = location.origin + to.fullPath;
  //获取第一个进入的路由
  if (isiOS) {
    if (window.entryUrl == '' || window.entryUrl == undefined) {
      window.entryUrl = url1
      console.log("entrtUrl", window.entryUrl);
    }
  }
  console.log(to.fullPath, 'tofullpath');
  console.log(to.path, 'topath');
  // 如果entryUrl中不包含秒杀路由名且目标路由是秒杀详情，执行一次刷新
  if (window.entryUrl && window.entryUrl.indexOf('/seckillDetail') == -1 && to.path.indexOf('/seckillDetail') !== -1) {
    console.log(111);
    if (true) {
      console.log("ios跳转秒杀重刷新");
      window.entryUrl = location.origin + to.fullPath; //重新赋秒杀页的签名地址
      location.assign(to.fullPath); //刷新页面
    }
  }
  // 如果entryUrl中不包含集赞路由名且目标路由是集赞详情，执行一次刷新
  if (window.entryUrl && window.entryUrl.indexOf('/likedetail') == -1 && to.path.indexOf('/likedetail') !== -1) {
    console.log(222);
    if (true) {
      console.log("ios跳转集赞重刷新");
      window.entryUrl = location.origin + to.fullPath; //重新赋秒杀页的签名地址
      location.assign(to.fullPath); //刷新页面
    }
  }

  const token = localStorage.getItem('token')
  console.log('to3', to);
  console.log('from3', from);
  // 核心操作，每次路由跳转将活动id写入localstorage,若无授权则重新授权
  // 浮窗功能，跳转时在query赋上actid,强制重新授权
  Vue.prototype.$utils.getQueryUserInfo(to.query);
  localStorage.setItem("fromPath", from.path);
  localStorage.setItem("toPath", to.path);
  if (to.path !== '/login') {
    localStorage.setItem("referer", to.fullPath);
  }
  if (!to.meta.NOTAuth && !token && process.env.NODE_ENV === 'production') {
    return router.push({
      name: 'login'
    });
  }
  if (to.path.indexOf('/actSignPage') !== -1 && !token) {
    return router.push({
      name: 'login'
    });
  }
  if (to.path.indexOf('/kpi') !== -1 || to.meta.isRegister) {
    // 更新后再获取
    Vue.prototype.$utils.updateUserInfo().then((res) => {
      const userType = localStorage.getItem("userType");
      const kpiUserStatus = localStorage.getItem("kpiUserStatus");
      if (([Vue.prototype.$utils.getMyPagePath()].includes(to.path)) && (userType === "act" || userType === "brand" || userType === "staff")) {
        return router.replace({
          path: "/kpi",
          query: {
            act_id: localStorage.getItem("act_id"),
          },
        });
      }
      if (to.path === '/spokesmannew' && (userType === "act" || userType === "brand" || userType === "staff")) {
        return router.replace({
          path: "/kpi",
          query: {
            act_id: localStorage.getItem("act_id"),
          },
        });
      }

      if (userType !== "act" && userType !== "brand" && userType !== "staff" && !to.meta.isRegister && process.env.NODE_ENV === 'production') {
        // 不是kpi用户，不允许操作kpi系统
        Vue.prototype.$toast('没有权限');
        let tmp = Vue.prototype.$utils.getMyPagePath()

        return router.replace({
          path: tmp,
          query: {
            act_id: localStorage.getItem("act_id"),
          },
        });
      } else {
        if (kpiUserStatus === 'under_review') {
          //  跳转去审核中
          return router.replace({
            path: "/registering",
            query: {
              act_id: localStorage.getItem("act_id"),
            },
          });
        } else if (kpiUserStatus === 'no_pass') {
          Vue.prototype.$toast('审核未通过');
          let tmp = localStorage.getItem("preheatPath") || 'prehddd';

          return router.replace({
            path: tmp,
            query: {
              act_id: localStorage.getItem("act_id"),
            },
          });
        } else if (kpiUserStatus === 'pass' && res.actChargeType === 'staff_auto' && res.recharged === 0 && res.rechargeMoney !== 0 && userType !== "act") {
          //  跳转去充值
          return router.replace({
            path: "/kpi/recharge",
            query: {
              act_id: localStorage.getItem("act_id"),
            },
          });
        } else if (kpiUserStatus === 'pass' && to.meta.isRegister) {
          return router.replace({
            path: "/kpi",
            query: {
              act_id: localStorage.getItem("act_id"),
            },
          });
        }
      }
    })
  }
  store.commit('CLAER_CANCEL');
  document.title = (to.meta && to.meta.title) || '首页';
  next()


});

router.afterEach((to, from) => {
  // const u = navigator.userAgent;
  // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // let url = location.origin + to.fullPath
  // if (isiOS) {
  //   if (window.entryUrl == '' || window.entryUrl == undefined) {
  //     window.entryUrl = url
  //     console.log("entrtUrl", window.entryUrl);
  //   }
  // }
})






export default router;